import { render, staticRenderFns } from "./SiteNavMobileV2.vue?vue&type=template&id=2bf7ab36&scoped=true&lang=pug"
import script from "./SiteNavMobileV2.vue?vue&type=script&lang=js"
export * from "./SiteNavMobileV2.vue?vue&type=script&lang=js"
import style0 from "./SiteNavMobileV2.vue?vue&type=style&index=0&id=2bf7ab36&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7ab36",
  null
  
)

export default component.exports